import React, { Fragment } from 'react'
import Container from '../components/container'

export default function DescriptionList({ content }) {
  const { heading, description, groups } = content

  return (
    <section className="standard-spacing bg-quaternary">
      <Container>
        <div className="xxx-grid">
          <div className="col-span-12 md:col-start-2 md:col-span-10 lg:col-start-4 lg:col-span-6">
            {heading && <h2 className="heading-3xl text-secondary">{heading}</h2>}
            {description && <p className="mt-4 body-lg 420:text-secondary exxxotica:text-tertiary">{description}</p>}
            {groups?.length && (
              <dl className="mt-8 md:mt-12">
                {groups.map(({ name, value }, key) => (
                  <Fragment key={key}>
                    {name && <dt className="heading-lg-accent mt-6 md:mt-8">{name}</dt>}
                    {value && <dd className="prose" dangerouslySetInnerHTML={{ __html: value }} />}
                  </Fragment>
                ))}
              </dl>
            )}
          </div>
        </div>
      </Container>
    </section>
  )
}
